export default "<div>\r\n<!-- <div> -->\r\n    <router-outlet>\r\n    </router-outlet>\r\n</div>\r\n<bart-loader></bart-loader>\r\n"